import * as React from "react";
import type { SVGProps } from "react";
const SvgPlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m10 8 .555-.832A1 1 0 0 0 9 8zm6 4 .555.832a1 1 0 0 0 0-1.664zm-6 4H9a1 1 0 0 0 1.555.832zm11-4a9 9 0 0 1-9 9v2c6.075 0 11-4.925 11-11zm-9 9a9 9 0 0 1-9-9H1c0 6.075 4.925 11 11 11zm-9-9a9 9 0 0 1 9-9V1C5.925 1 1 5.925 1 12zm9-9a9 9 0 0 1 9 9h2c0-6.075-4.925-11-11-11zM9.445 8.832l6 4 1.11-1.664-6-4zm6 2.336-6 4 1.11 1.664 6-4zM11 16V8H9v8z"
    />
  </svg>
);
export default SvgPlayCircle;
